export default __webpack_public_path__ + "static/media/ClearKeyLogov2White.c24b77e3.svg";